<template>
  <div class="overlay" @click="$emit('closeErrorPopup')">
    <div class="tooltip">
      <div class="tooltip-icon">!</div>
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPopup",
  props: {
    text: {
      type: String,
      default: "Выберите один из вариантов ответа"
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* выше остальных элементов */
}

.tooltip {
  position: absolute;
  top: 30%;
  background: white;           /* белый фон */
  border: 1px solid grey;      /* серый цвет рамки */
  color: black;                /* чёрный текст */
  padding: 10px 10px 10px 40px; /* отступы */
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-size: 13px;
  z-index: 1000;
  white-space: nowrap;
}

/* Треугольник под тултипом */
.tooltip::after {
    content: "";
    position: absolute;
    bottom: -8px;                /* позиция треугольника */
    left: 20px;                  /* смещение по горизонтали */
    border-width: 8px 8px 0 8px; /* размеры треугольника */
    border-style: solid;
    border-color: white transparent transparent transparent; /* белый треугольник */
    /* border-top: 1px solid grey; */
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
}

/* Квадрат с восклицательным знаком слева */
.tooltip .tooltip-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-color: #FFA500; /* оранжевый фон */
  color: white;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  border-radius: 3px;
  border: 2px solid white;
  box-sizing: border-box;
  user-select: none;
  text-align: center;
  pointer-events: none; /* Запрет на взаимодействие с квадратом */
}

</style>
